import styled from "styled-components";
import { variant } from "styled-system";
import { apolloZindexTooltip, apolloFontFamilySub, apolloFontSizeSub, apolloFontWeightBody, apolloLineHeightBody, apolloSpaceStack1X, apolloSpaceStack6X, apolloSpaceStackHalfX, apolloSpaceInset1X, apolloSpaceInset2X, } from "@nexthink/apollo-tokens";
import { StyledActionMenu } from "../menu/ActionMenu.style";
import Box from "../box/Box";
// The caret is a 45deg tilted square, so its width is the square's diagonal,
// thus we use the sqrt(2) constant to calculate it: https://en.wikipedia.org/wiki/Diagonal#Regular_polygons
export const squareSideToDiagonalRatio = 1.4142;
export const caretWidth = 20;
// The offset positions need to be calculated as if the square was not tilted.
export const caretWidthNotTilted = caretWidth / squareSideToDiagonalRatio;
export const caretWidthDiff = caretWidth - caretWidthNotTilted;
export const borderRadius = 4;
export const caretPosition = 16 + caretWidthDiff / 2;
export const caretOffset = 2;
export const caretCenterOffset = caretWidthNotTilted / 2;
const hasPositionForMinWidth = (position) => position === "topLeft" || position === "topRight" || position === "bottomLeft" || position === "bottomRight";
const hasPositionForMinHeight = (position) => position === "leftTop" || position === "rightTop" || position === "leftBottom" || position === "rightBottom";
export const StyledTooltip = styled.div.withConfig({ displayName: "StyledTooltip_APC-7311-productShell", componentId: "sc-18h27n1" })(({ maxWidth, theme, position }) => (Object.assign(Object.assign({ borderRadius,
    maxWidth, display: "inline-flex", position: "relative", zIndex: apolloZindexTooltip, color: theme.colors.apolloColorTextPopoverPrimary, backgroundColor: theme.colors.apolloColorBackgroundPopover, boxShadow: theme.colors.apolloBoxShadowTooltip, fontFamily: apolloFontFamilySub, fontSize: apolloFontSizeSub, fontWeight: apolloFontWeightBody, lineHeight: apolloLineHeightBody }, (hasPositionForMinWidth(position) && { minWidth: apolloSpaceStack6X })), (hasPositionForMinHeight(position) && { minHeight: apolloSpaceStack6X }))), ({ theme }) => variant({
    variants: {
        base: {
            color: theme.colors.apolloColorTextPrimary,
            backgroundColor: theme.colors.apolloColorBackgroundTooltip,
        },
    },
}));
export const StyledCaret = styled.span.withConfig({ displayName: "StyledCaret_APC-7311-productShell", componentId: "sc-1dcaluf" })(({ theme }) => ({
    border: `${caretWidthNotTilted / 2}px solid transparent`,
    borderRadius: "3px 0 0",
    boxSizing: "border-box",
    height: caretWidthNotTilted,
    position: "absolute",
    width: caretWidthNotTilted,
    zIndex: -1,
    borderColor: theme.colors.apolloColorBackgroundPopover,
    backgroundColor: theme.colors.apolloColorBackgroundPopover,
}), ({ theme }) => variant({
    variants: {
        base: {
            borderColor: theme.colors.apolloColorBackgroundTooltip,
        },
    },
}));
export const StyledContent = styled.div.withConfig({ displayName: "StyledContent_APC-7311-productShell", componentId: "sc-pz4w5r" })(({ variant: variantStyle }) => variant({
    prop: "$spacing",
    variants: {
        compact: Object.assign({}, (!variantStyle && { padding: apolloSpaceInset1X })),
        comfortable: {
            padding: apolloSpaceInset2X,
        },
    },
}), ({ variant }) => (Object.assign(Object.assign({}, (variant && { padding: 0 })), { borderRadius, overflow: "hidden", width: "100%", [StyledActionMenu]: {
        borderRadius,
        boxShadow: "none",
    } })), ({ theme }) => variant({
    variants: {
        base: {
            border: `2px solid ${theme.colors.apolloColorBackgroundTooltip}`,
        },
    },
}));
const marginOnFirstSameElement = {
    marginTop: apolloSpaceStack1X,
    "& + &": {
        marginTop: 0,
    },
};
const marginOnNextOtherElement = {
    "& + *": {
        marginTop: apolloSpaceStack1X,
    },
};
export const StyledTooltipTitle = styled(Box).withConfig({ displayName: "StyledTooltipTitle_APC-7311-productShell", componentId: "sc-s7le1d" })(({ theme }) => (Object.assign(Object.assign({}, theme.textStyles.subStrong), { marginBottom: apolloSpaceStackHalfX, "& ~ &": {
        marginTop: apolloSpaceStack1X,
    } })));
export const StyledTooltipText = styled(Box).withConfig({ displayName: "StyledTooltipText_APC-7311-productShell", componentId: "sc-x0z6sp" })(Object.assign({}, marginOnNextOtherElement));
export const StyledTooltipKeyValue = styled(Box).withConfig({ displayName: "StyledTooltipKeyValue_APC-7311-productShell", componentId: "sc-1l8qop6" })(Object.assign(Object.assign({}, marginOnFirstSameElement), marginOnNextOtherElement));
export const StyledTooltipLink = styled(Box).withConfig({ displayName: "StyledTooltipLink_APC-7311-productShell", componentId: "sc-8h5dox" })(Object.assign(Object.assign({}, marginOnFirstSameElement), marginOnNextOtherElement));
//# sourceMappingURL=Tooltip.style.js.map